import React from 'react';
import { MessagesSquareIcon, SearchCheckIcon, RocketIcon, HeartHandshakeIcon } from 'lucide-react';
import { Card, CardBody } from '../Card';
import { Badge } from '../Badge';
type Step = {
  no: string;
  icon: React.ReactNode;
  title: string;
  body: string;
};
const STEPS: Step[] = [{
  no: '01',
  icon: <MessagesSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-264" data-mp="2818wtv54h9sp" />,
  title: 'まずは相談',
  body: '今の困りごとや一日の流れをお聞きします。専門用語は使いません。気軽にお話しください。'
}, {
  no: '02',
  icon: <SearchCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-265" data-mp="2h0nogxx0zqes" />,
  title: '課題の診断',
  body: '10年以上の経験をもとに、どこを自動化すれば一番ラクになるかを見極め、最適な形をご提案します。'
}, {
  no: '03',
  icon: <RocketIcon className="h-5 w-5" aria-hidden="true" data-id="element-266" data-mp="2ltyl6684iqsz" />,
  title: 'まるごと導入',
  body: '設定や準備はすべてこちらで対応。あなたの手間は最小限で、最短翌日から使いはじめられます。'
}, {
  no: '04',
  icon: <HeartHandshakeIcon className="h-5 w-5" aria-hidden="true" data-id="element-267" data-mp="2vr37c61yym9s" />,
  title: 'ずっと運用サポート',
  body: '導入して終わりではありません。困ったときはいつでも相談できる、伴走するパートナーであり続けます。'
}];
export function ProcessSection() {
  return <section id="process" className="w-full scroll-mt-24 bg-white" data-id="element-268" data-mp="3qpcnpzwbp59m">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-269" data-mp="3lof5jnbbcb84">
        <div className="mx-auto max-w-2xl text-center" data-id="element-270" data-mp="3gplstx3uoo90">
          <Badge variant="amber" data-id="element-271" data-mp="3gq3vpcl0q0pw">導入の流れ</Badge>
          <h2 className="mt-4 text-2xl font-bold text-text sm:text-3xl" data-id="element-272" data-mp="3co9yjea17euh">
            ITが苦手でも大丈夫。最後まで伴走します
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted" data-id="element-273" data-mp="d94vnt16m1ps">
            相談から運用まで、専門家が隣に立って一緒に進めます。あなたは「おまかせ」でかまいません。
          </p>
        </div>

        <ol className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-274" data-mp="8c4pli4c0yyo">
          {STEPS.map(s => <li key={s.no} data-id="element-275" data-mp="3gpfn19g3n7j">
              <Card variant="outlined" className="h-full" data-id="element-276" data-mp="3vne6sktr14l3">
                <CardBody data-id="element-277" data-mp="3vkrvqb7ng6y4">
                  <div className="flex items-center justify-between" data-id="element-278" data-mp="vz4jydp77cs5">
                    <span className="text-2xl font-bold text-deep-navy/25" data-id="element-279" data-mp="w1h5f0u6059y">
                      {s.no}
                    </span>
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-deep-navy/5 text-deep-navy" data-id="element-280" data-mp="2lfynw3djw8km">
                      {s.icon}
                    </span>
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-text" data-id="element-281" data-mp="2brgq7v0kihl7">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-text-muted" data-id="element-282" data-mp="2gogvw4ti9ibs">
                    {s.body}
                  </p>
                </CardBody>
              </Card>
            </li>)}
        </ol>
      </div>
    </section>;
}